import reducer from './reducers/index';
import routes from '../routes';
import * as publicAFActions from './actions'
import * as publicAFOperations from './operations'
import * as publicAFSelectors from './selectors'

export {
    publicAFActions,
    publicAFOperations,
    publicAFSelectors,
}

export default {
    routes,
    reducer
}
